// Import: Middleware Action & Custom Types
import { CLEAN_LIST_SIM_IPB, CLEAN_LIST_SIM_IPB_ERROR } from '_models/redux/types';

// Action function
export const cleanListSimIpbClean = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_LIST_SIM_IPB,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_LIST_SIM_IPB_ERROR,
      payload: undefined,
    });
  }
};
